module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'success',
    综合评价: "Overall Evaluation",
    inputNotSame: "Input Not Same",
    example: 'Example',
    // 选择语言
    popupTitle: 'Select Language',
    // 发送
    send: 'Confirm',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 发送邮件
    sendEmail: 'Send Email',
    // 改变语言
    changeLanSes: 'Language switch successful',
    // 系统标题
    title: 'Voice of Buyer',
    // 系统解释
    details: 'Listening to the voice of buyers, providing quality products and services, thanks for sharing.',
    fileSizeOver: "File is too large, only images within 10MB are supported.",
    lowTextarea: 'Your feedback will assist us in continually enhancing our products and services.',
    placeholderOrderNo: "Please enter the order number (format: 000-0000000-0000000)",
    "picUploadSuccessText": "Image uploaded successfully",
    "picUploadErrorText": "Image upload failed",
    "orderNotExistText": "The order does not exist",
    "orderInvalidText": "This order is invalid",
    "networkErrorText": "Network error",
    "orderErrorText": "Order error",
    // step1
    formBasic: {
        title: 'Register Your Warranty Now! Claim Your <span style="color:#F40000">Mystery Box</span>, Exclusive Offer for Existing Customers.',
        form_name: 'Name',
        form_email: 'Email',
        form_order: 'Order Id',
        form_order_error_placeholder: 'Please enter the order number (format: 000-0000000-0000000)',
        order_why: '*How to find your Order ID?',
        order_answer: '*We don’t share your personal info with anyone. Your personal information is secure and used solely for your warranty activation.',
        btn_text: 'Activate Now',
        "form_name_placeholder": "Please enter your name",
        "form_email_placeholder": "Please enter your email",
        "form_email_error_placeholder": "Please enter a valid email",
        "form_order_placeholder": "Please enter your order number"
    },
    // step2
    showGiftCard: {
        title: `Congratulation!</br>
Your warranty is activated!`,
        text: 'Sharing your voice and you can get a <span style="color:#F40000">Mystery Box</span>. (About 1 minute)',
        gift_card_text: 'What You Can Get',
        btn_text: 'Next Step'
    },
    // step3
    star: {
        title: 'Are you satisfied with this product or our service?',
        text: ' Please give a star rating for the product below:',
        star__placeholder: 'Please rate alquestions beforesubmitting!',
        written: 'Add a written review: <span style="color:#F40000">（Optional）</span>',
        written_placeholder: 'What did you like? What did use this product for?',
        btn_text: 'Next Step'
    },
    // step4
    ensureEmail: {
        title: `Congratulation!</br>
You've finished the survey.
`,
        text: `Please double confirm the email address, you will receive gift code via this email address:</br>
 <span style="color:#F40000">redeem@amazonsurveyzone.com</span>`,
        email_placeholder: 'Please double confirm the email address!',
        btn_text: 'Next Step'
    },
    // step5
    channelSelect: {
        title: `Your feedback matters! `,
        text: `Share your product reviews on Amazon to help other customers make right decisions. Join the review-sharing community now and earning extra rewards.`,
        footer: '*About The Gift:</br> No Shipping Charges, No Hidden Fees, No Credit Card Required',
        btn_text: 'I Want It'
    },
    // step6
    uploadPic: {
        title: `Please upload the screenshot of your Amazon review after you write.`,
        text: ` Once your review is successfully posted on Amazon, we will contact you via email: <span style="color:#F40000">redeem@amazonsurveyzone.com</span> and issue you the Mystery Box.`,
        add_pic: 'Add Picture',
        add_pic_text: 'Usually Amazon will take 2-3 days to review.',
        btn_text: 'Next Step'
    },
    // step7
    cityForm: {
        title: '*Accessory</br>Shiping Address: ',
        text: '(Plz confirm your shipping address, the free gift will be arranged in 3-5 working days.)',
        form_city: 'City',
        form_state: 'State/Region',
        form_postal_code: 'Postal Code',
        form_country: 'Country',
        btn_text: 'Confirm',
        "form_city_placeholder": "Please enter your city",
        "form_state_placeholder": "Please enter your area",
        "form_postal_code_placeholder": "Please enter your postal code",
        "form_country_placeholder": "Please enter your country"
    },
    // step7
    paypalForm: {
        title: '*Account of Receiving Gift Card: ',
        text: '(Please check your account information carefully)',
        form_paypal: 'Paypal Account',
        form_ensure_paypal: 'Double Confirm Paypal Account',
        form_paypal_name: 'Name',
        btn_text: 'Confirm',
        "form_paypal_placeholder": "Please enter your PayPal account",
        "form_ensure_paypal_placeholder": "Please confirm your PayPal account",
        "form_paypal_name_placeholder": "Please enter your PayPal name"
    },
    // thanks-all
    thanksAll: {
        title: 'Grateful for Your Contribution!',
        // title_desc1: 'Thank you for participating in our product survey!',
        // title_desc2: 'projector survey!',
        text: `Your valuable opinions will help us to improve product quality. 
If you have any questions during use, please feel free to contact us.`
    },
    // thanks
    thanks: {
        title: 'Congratulation!',
        title_desc1: `Your warranty is activated!
Thank you very much for your time.`,
        title_default_paypal_desc1: `Your warranty is activated!
Thank you very much for your time. Your reward will be issued within 24 to 72 hours.`,
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}